export default "__VITE_ASSET__DxeKd7Wf__"